import { render, staticRenderFns } from "./DataManagementLayout.vue?vue&type=template&id=3f38121d&scoped=true"
import script from "./DataManagementLayout.vue?vue&type=script&lang=js"
export * from "./DataManagementLayout.vue?vue&type=script&lang=js"
import style0 from "./DataManagementLayout.vue?vue&type=style&index=0&id=3f38121d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38121d",
  null
  
)

export default component.exports